<template>
	<v-content>
		<v-container fluid fill-height>
			<v-layout row>
				<v-flex xs12>
				<div class="display-3 text-center">
					Hoşgeldin
				</div>
				</v-flex>
    		</v-layout>
    	</v-container>
    </v-content>
</template>


<script>
    export default {

        computed: {
            getAuth() {
                return this.$store.getters.getAuth;
            }
        }
    }
</script>